/* [Modified by Codex at 2026-10-12] 把预计到货日期放到空闲时段计算以优先响应产品选择 */
(() => {
  'use strict';
  const render = (root) => {
    root.querySelectorAll('.pv-arrival-date').forEach((element) => {
      if (!element.isConnected) return;
      const earliest = Number.parseInt(element.dataset.daysMin, 10) || 15;
      const latest = Number.parseInt(element.dataset.daysMax, 10) || 25;
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const format = (days) => {
        const date = new Date();
        date.setDate(date.getDate() + days);
        return `${months[date.getMonth()]}. ${date.getDate()}`;
      };
      element.textContent = `${format(earliest)} - ${format(latest)}`;
    });
  };
  const schedule = (root) => {
    if ('requestIdleCallback' in window) window.requestIdleCallback(() => render(root), { timeout: 2000 });
    else window.setTimeout(() => render(root), 0);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => schedule(document), { once: true });
  else schedule(document);
  document.addEventListener('shopify:section:load', (event) => schedule(event.target));
})();
/* [End] */
